import React from "react";
import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    justifyContent: "center",
    textAlign: "center",
    marginBottom: "5.5em",
  },
  title: {
    padding: "3em 5em",
    [theme.breakpoints.down("xs")]: {
      padding: "3em 0",
    },
  },
  pos: {
    marginBottom: 12,
  },
  avatar: {
    display: "flex",
    justifyContent: "center",
    marginBottom: "0.5em",
  },
  avt: {
    width: "3.7em",
    height: "3.7em",
  },
  person: {
    padding: ".9em 0",
  },
}));

export default function BottomTranslation({ person, msg, avatar, job }) {
  const classes = useStyles();
  return (
    <Container className={classes.root} variant="outlined">
      <Typography variant="h2" color="primary" className={classes.title}>
        {msg}
      </Typography>
      <Container className={classes.avatar}>
        <Avatar className={classes.avt} src={avatar} />
      </Container>
      <Typography
        variant="subtitle1"
        color="primary"
        className={classes.person}
      >
        {person}
      </Typography>
      <Typography className={classes.pos} variant="subtitle2" color="secondary">
        {job}
      </Typography>
    </Container>
  );
}
